/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useEffect } from 'react';

import { env } from '../env.ts';

const useSelligent = () => {
  useEffect(() => {
    const existingScript = document.getElementById('selligent');

    if (!existingScript) {
      const defaultScriptElement = document.createElement('script');
      defaultScriptElement.src = env.REACT_APP_SELIGENT_DEFAULT_SCRIPT_URL;
      defaultScriptElement.id = 'selligent-default';

      const trackingScriptElement = document.createElement('script');
      trackingScriptElement.src = env.REACT_APP_SELIGENT_TRACKING_SCRIPT_URL;
      trackingScriptElement.id = 'selligent-tracking';

      document.body.appendChild(defaultScriptElement);
      document.body.appendChild(trackingScriptElement);
    }

    return () => {
      document.getElementById('selligent-default')?.remove();
      document.getElementById('selligent-tracking')?.remove();

      if (typeof wa !== 'undefined') {
        wa = undefined;
      }
    };
  }, []);
};

export default useSelligent;
